import { Injectable } from '@angular/core';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { CaseProduct } from '../../mortgage-application/models/case-product.model';
import { FormApplication } from '../models/form-application.model';

@Injectable()
export class PartAndPartProductService {
  public isProductPartRepaymentPartInterest: boolean;
  public isProductInterestOnly: boolean;

  public firstProduct: CaseProduct;
  public secondProduct: CaseProduct;
  public application: FormApplication;

  public setRepaymentTypeFlags(): void {
    this.isProductPartRepaymentPartInterest =
      this.application.RepaymentTypeCodeCache === ReferenceDataOptionLists.RepaymentTypePartAndPart;
    this.isProductInterestOnly =
      this.application.RepaymentTypeCodeCache === ReferenceDataOptionLists.RepaymentTypeInterestOnly;
  }

  public setLoanAmount(newAmount: number): void {
    if (!this.application) {
      return;
    }

    this.application.LoanAmountCache = newAmount;
    if (newAmount === null || newAmount === undefined) {
      if (this.secondProduct) {
        this.secondProduct.LoanAmount = undefined;
      }
    } else if (this.isProductPartRepaymentPartInterest) {
      this.secondProduct.LoanAmount = newAmount - (this.firstProduct.LoanAmount || 0);
    } else {
      this.firstProduct.LoanAmount = newAmount;
    }
  }

  public createRepaymentPartProduct(): void {
    this.secondProduct = new CaseProduct();
    if (this.firstProduct.Product) {
      delete (this.firstProduct.Product as any).$id;
      this.secondProduct.ProductID = this.firstProduct.ProductID;
      this.secondProduct.Product = this.firstProduct.Product;
    }

    this.secondProduct.LoanTermMonths = this.firstProduct.LoanTermMonths;
    this.secondProduct.LoanTermYears = this.firstProduct.LoanTermYears;
    this.secondProduct.LoanAmount = this.application.LoanAmountCache;
    this.secondProduct.RepaymentTypeCode = ReferenceDataOptionLists.RepaymentTypeRepayment;
    this.secondProduct.CaseProductID = 0;
  }

  public setRepaymentType(
    newRepaymentType: string,
    addRepaymentPartProduct: (applicationProducts: Array<any>, repaymentPartProduct: CaseProduct) => void,
    deleteRepaymentPartProduct: (applicationProducts: Array<any>) => void,
    applicationProducts: Array<any>
  ): void {
    this.application.RepaymentTypeCodeCache = newRepaymentType;
    if (this.isProductPartRepaymentPartInterest) {
      if (newRepaymentType !== ReferenceDataOptionLists.RepaymentTypePartAndPart) {
        this.firstProduct.LoanAmount = this.application.LoanAmountCache;
        this.firstProduct.RepaymentTypeCode = newRepaymentType;
        deleteRepaymentPartProduct(applicationProducts);
      }
    } else {
      if (newRepaymentType === ReferenceDataOptionLists.RepaymentTypePartAndPart) {
        this.firstProduct.RepaymentTypeCode = ReferenceDataOptionLists.RepaymentTypeInterestOnly;
        this.firstProduct.LoanAmount = undefined;
        this.createRepaymentPartProduct();
        addRepaymentPartProduct(applicationProducts, this.secondProduct);
      } else {
        this.firstProduct.RepaymentTypeCode = newRepaymentType;
      }
    }
    this.setRepaymentTypeFlags();
  }

  public setInterestOnlyPart(value: number): void {
    this.firstProduct.LoanAmount = value;
    this.secondProduct.LoanAmount = this.application.LoanAmountCache - (value || 0);
  }
}
